import React from 'react'
import Select from 'react-select'

export type OnboardingPopupSelectFilterType = {
  chapterIndex: number
  chapterId: number | undefined
  chapterName: string
}

interface IOnboardingPopupSelectProps {
  value: number | undefined
  filterTypes: OnboardingPopupSelectFilterType[]
  onChange: (value: number | undefined) => void
}

export const OnboardingPopupSelect: React.FC<IOnboardingPopupSelectProps> = (
  props
) => {
  const { value, filterTypes, onChange } = props

  const selectOptions = [
    {
      label: '모든 회차의 팝업',
      value: undefined,
    },
    ...filterTypes.map((filterType) => ({
      label: `${filterType.chapterIndex}화 (${filterType.chapterName})`,
      value: filterType.chapterId,
    })),
  ]

  return (
    <Select
      placeholder="회차"
      value={selectOptions.find((v) => v.value === value)}
      // @ts-ignore
      onChange={(v) => onChange(v.value)}
      options={selectOptions}
      styles={{
        // Fixes the overlapping problem of the component
        menu: (provided) => ({ ...provided, zIndex: 2 }),
      }}
    />
  )
}
